import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { style } from '../../utils/style.js';
import { useButton } from './useButton.js';
const buttonStyleMap = {
    primary: 'text-white bg-primary-main hover:bg-primary-hover active:bg-primary-active',
    secondary: 'text-primary-main bg-main-divider hover:text-white hover:bg-primary-hover active:bg-primary-active',
};
const secondaryButtonStyleMap = {
    primary: style('group-data-secondary:text-primary-main group-data-secondary:bg-white', 'group-data-secondary:hover:text-white group-data-secondary:hover:bg-primary-hover', 'group-data-secondary:active:bg-primary-active'),
    secondary: style('group-data-secondary:text-white group-data-secondary:bg-white/20', 'group-data-secondary:hover:bg-primary-hover', 'group-data-secondary:active:bg-primary-active'),
};
export const Button = JSX(({ children, ...props }) => {
    const button = useButton();
    const { className, version = 'primary', active, disabled, type = 'button', rounded = true, role, onClick, } = button(props);
    return (_jsx("button", { className: style('font-sans px-9 py-4', 'flex justify-center items-center gap-xs', {
            'text-white bg-primary-active': active,
            'bg-main-gray text-main-disabled cursor-not-allowed': disabled,
            'rounded-md': rounded,
        }, !active && !disabled
            ? style(buttonStyleMap[version], secondaryButtonStyleMap[version])
            : '', className), type: type, role: role, onClick: onClick, children: children }));
});
//# sourceMappingURL=Button.js.map